// extracted by mini-css-extract-plugin
export var columnList = "_cc-0";